import { Text } from "components/atoms";
import { Swiper, SwiperSlide } from "swiper/react";
import { ISectionCardsHotel } from "./props";
import "swiper/css";
import "swiper/css/navigation";
import "./styles.scss";
import { Animations } from "components/molecules";
import CardPromotionHotel from "components/molecules/CardPromotionHotel";

const SectionCardsHotel = ({
  data,
  title,
  sectionref,
  textoTooltipIgv,
  textoTooltipIgvCard,
  coin,
  idTravelClick,
}: ISectionCardsHotel) => {
  return (
    <section>
      <div className="promotions-hotel" ref={sectionref}>
        <div className="promotions-hotel__container">
          <Text type="subtitle" text={title} className={"subtitle"} />

          <div className="promotions-hotel__container--description">
            <Swiper
              slidesPerView={"auto"}
              grabCursor={true}
              navigation={true}
              className="promotions-hotel__container--description--swiper"
            >
              {data && Array.isArray(data) && data.length > 0 ? (
                <>
                  {data.map((item: any, index: number) => {
                    const up_to_quotes = ["interbank", "bcp", "bbva"].some(
                      (bank) => item.nombre.toLowerCase().includes(bank)
                    )
                      ? 12
                      : ["diners"].some((bank) =>
                          item.nombre.toLowerCase().includes(bank)
                        )
                      ? 6
                      : 0;
                    const updatedItem = {
                      ...item,
                      up_to_quotes
                    };
                    return (
                      <SwiperSlide key={index}>
                        <CardPromotionHotel
                          key={index}
                          data={updatedItem}
                          textoTooltipIgv={textoTooltipIgv}
                          textoTooltipIgvCard={textoTooltipIgvCard}
                          coin={coin}
                          idTravelClick={idTravelClick}
                        />
                      </SwiperSlide>
                    );
                  })}
                </>
              ) : (
                <>
                  <SwiperSlide>
                    <Animations type="skeletonContent">
                      <div style={{ height: 370, width: 218 }}></div>
                    </Animations>
                  </SwiperSlide>
                </>
              )}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

SectionCardsHotel.defaultProps = {
  bgColor: "white",
  titleColor: "black",
};

export default SectionCardsHotel;
